<template>
  <div>
    <div class="footer">
      <b-container fluid>
        <div class="signup_letter">
          <b-form inline class="justify-content-between">
            <img src="@/assets/images/icons/newletter.png" alt />
            <h3>Sign Up For Newsletter</h3>
            <b-input
              type="text"
              id="input-name"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Your name"
            ></b-input>
            <b-input
              type="email"
              id="input-email"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Your email"
            ></b-input>
            <b-button type="submit" variant="primary">Submit</b-button>
          </b-form>
        </div>
        <div class="footer_links">
          <b-row>
            <b-col cols="12" lg="4" md="6" sm="12">
              <div class="footer_items">
                <img class="logo" src="@/assets/images/footerlogo.png" alt />
                <p>
                  564, Manon road, F1 456 Caron Town.
                  <br />Office No 3456
                  <br />info@example.com
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="2" md="6" sm="12">
              <div class="footer_items">
                <h2>Links</h2>
                <b-nav vertical>
                  <b-nav-item to="/">Apply a loan</b-nav-item>
                  <b-nav-item to="/repayment">Repayment</b-nav-item>
                  <b-nav-item to="/news">News &amp; Promos</b-nav-item>
                  <b-nav-item to="/faqs">Faqs</b-nav-item>
                  <b-nav-item to="/contacts">Contacts</b-nav-item>
                </b-nav>
              </div>
            </b-col>
            <b-col cols="12" lg="2" md="6" sm="12">
              <div class="footer_items">
                <h2>About Us</h2>
                <b-nav vertical>
                  <b-nav-item to="/contacts">About Us</b-nav-item>
                  <b-nav-item to="/articles">Blog</b-nav-item>
                  <b-nav-item to="/contacts">Contact Us</b-nav-item>
                  <b-nav-item to="/login">Sign In</b-nav-item>
                  <b-nav-item to="">My Account</b-nav-item>
                </b-nav>
              </div>
            </b-col>
            <b-col cols="12" lg="4" md="6" sm="12">
              <div class="footer_items">
                <h2>Contact Us</h2>
                <p>
                  Our company is the most poular in
                  the world. Many desktop publishing
                  packages and web page editors now
                  use their.
                </p>
                <b-nav pills class="mt-4 socials">
                  <b-nav-item>
                    <img src="@/assets/images/icons/fb.png" alt />
                  </b-nav-item>
                  <b-nav-item>
                    <img src="@/assets/images/icons/twitter.png" alt />
                  </b-nav-item>
                  <b-nav-item>
                    <img src="@/assets/images/icons/insta.png" alt />
                  </b-nav-item>
                </b-nav>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <div class="all_rights">
      <b-container fluid>
        <div class="rights_items">
          <b-nav pills>
            <b-nav-item to="/contacts/terms">Terms &amp; Condition</b-nav-item>
            <b-nav-item to="/contacts/privacy">Privacy Policy</b-nav-item>
            <b-nav-item to="">Sitemap</b-nav-item>
          </b-nav>
          <p>@2020, RAJ5 Lending Corp. All Right Reserved</p>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerComponent"
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 0 0 60px;
  background: url("../assets/images/bg_footer.jpg") no-repeat;
  background-position: center;
  background-size: cover;
  .signup_letter {
    padding: 20px;
    border-radius: 4px;
    background-color: rgb(255, 255, 255);
    box-shadow: 2.5px 4.33px 24px 0px rgba(0, 0, 0, 0.11);
    position: relative;
    top: -40px;
    input.form-control {
      height: 50px;
      border: 1px solid $base-color-lightblue;
      background: $bg-lightgray;
      flex-grow: 1;
    }
    .btn {
      height: 50px;
      min-width: 105px;
      border: 0;
      background: $base-color-blue;
    }
    img {
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      margin-right: 20px;
    }
  }
  .footer_links {
    margin-top: 20px;
    .footer_items {
      .logo {
        margin-bottom: 20px;
        width: 220px;
      }
      p {
        margin-bottom: 0;
        color: #fff;
      }
      h2 {
        font-size: 24px;
        font-weight: 700;
        color: #fff;
      }
      .nav {
        li {
          a {
            color: #fff;
            padding: 0 0 4px;
          }
        }
      }
      .socials {
        li {
          a {
            margin-right: 20px;
          }
        }
      }
    }
  }
}
.all_rights {
  .rights_items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    ul {
      li {
        a {
          font-size: 12px;
          color: #434343;
          text-decoration: none;
          padding-left: 0;
        }
      }
    }
    p {
      margin-bottom: 0;
      font-size: 12px;
    }
  }
}
@media (max-width: 600px) {
  .all_rights .rights_items {
    flex-direction: column;
  }
}
</style>